export default __webpack_public_path__ + "static/media/330C.16022293.pdf";